import React from 'react';
import axios from 'axios';
import { Loading, ToastNotification } from 'carbon-components-react';
import { t } from '../../RI18n';
import './style.css';

class DatasourceConfiguration extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      backendData: {},
    };
  }

  componentDidMount() {
    axios
      .get('/sam/todo_list/datasource_configuration.json')
      .then((result) => {
        this.setState({
          isLoaded: true,
          backendData: result.data,
        });
      })
      .catch(() => {
        this.setState({
          isLoaded: true,
          error: true,
        });
      });
  }

  render() {
    const { error, isLoaded, backendData } = this.state;

    if (backendData.to_display === false) {
      return null;
    }

    if (error) {
      console.log(t('todolist.configure_datasource.error'));
      return null;
    }
    if (!isLoaded) {
      return (
        <span>
          <br />
          <Loading small withOverlay={false} />
        </span>
      );
    }
    if (backendData.configure_disconnected_scanners === true) {
      if (this.props.notify) {
        this.props.updateToDos();
      }

      const renderedReportStatusText = t('widget.status.warning');
      const titleText = t('todolist.configure_datasource.title');

      const titleTextWithTooltip = (
        <span
          className="notification_text"
          title={renderedReportStatusText}
        >
          {titleText}
        </span>
      );
      const subtitleText = (
        <span className="notification_text">
          <span
            dangerouslySetInnerHTML={{
              __html: t('todolist.configure_datasource.caption_disconnected_ds'),
            }}
          />
        </span>
      );

      const captionText = (
        <div
          className="notification_text"
          dangerouslySetInnerHTML={{
            __html: t('todolist.configure_datasource.details'),
          }}
        />
      );

      return (
        <ToastNotification
          className="notification_style"
          title={titleTextWithTooltip}
          subtitle={subtitleText}
          caption={captionText}
          hideCloseButton
          kind="warning"
          aria-label={t('todolist.aria_label', {
            name: t('todolist.configure_datasource.name'),
            status: renderedReportStatusText,
          })}
          role="region"
        />
      );
    }

    return null;
  }
}

export default DatasourceConfiguration;
